import { useEffect, useState } from "react";
import { api, fmtDate } from "@/admin/api";
import { PageHeader, Badge, Empty, Spinner } from "@/admin/ui";

const LABEL = {
  login: "Signed in", login_failed: "Failed sign-in", password_ok: "Password accepted", otp_sent: "Code sent", "2fa_failed": "Wrong 2FA code",
  totp_enrolled: "Authenticator connected", totp_reset: "Authenticator reset", logout: "Signed out", logout_all: "All sessions revoked",
  password_changed: "Password changed", password_change_failed: "Password change failed", profile_updated: "Profile updated",
  enquiry_updated: "Enquiry updated", enquiry_deleted: "Enquiry deleted", waitlist_deleted: "Waitlist entry removed",
  content_saved: "Content published", content_reset: "Content reset",
};

export default function Audit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data.items)); }, []);
  if (!items) return <Spinner />;

  return (
    <div data-testid="admin-audit">
      <PageHeader eyebrow="Security" title="Audit log" sub="Every sign-in attempt and change made in this panel, newest first." />
      {items.length === 0 ? <Empty>Nothing logged yet.</Empty> : (
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="bg-slate-50 text-left font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500">
              <tr><th className="px-5 py-3">When</th><th className="px-5 py-3">Action</th><th className="px-5 py-3">Detail</th><th className="px-5 py-3">IP</th><th className="px-5 py-3">Result</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((a) => (
                <tr key={a.id} className="hover:bg-slate-50/60">
                  <td className="px-5 py-3 text-xs text-slate-500 whitespace-nowrap">{fmtDate(a.at)}</td>
                  <td className="px-5 py-3 font-semibold text-[#0B1528]">{LABEL[a.action] || a.action}</td>
                  <td className="px-5 py-3 text-slate-600 text-xs max-w-md truncate" title={a.detail}>{a.detail}</td>
                  <td className="px-5 py-3 font-mono text-xs text-slate-500">{a.ip}</td>
                  <td className="px-5 py-3"><Badge tone={a.ok ? "green" : "red"}>{a.ok ? "ok" : "blocked"}</Badge></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
